<script>import { getTransform, setCustomFontSize } from "./utils.js";
let clazz = void 0;
export { clazz as class };
export let id = void 0;
export let style = void 0;
export let icon;
export let size = void 0;
export let color = void 0;
export let fw = false;
export let pull = void 0;
export let scale = 1;
export let translateX = 0;
export let translateY = 0;
export let rotate = void 0;
export let flip = void 0;
export let spin = false;
export let pulse = false;
export let primaryColor = "";
export let secondaryColor = "";
export let primaryOpacity = 1;
export let secondaryOpacity = 0.4;
export let swapOpacity = false;
let svgElement;
$:
  svgElement && size && setCustomFontSize(svgElement, size);
$:
  i = icon && icon.icon || [0, 0, "", [], ""];
$:
  transform = getTransform(scale, translateX, translateY, rotate, flip, 512);
</script>

{#if i[4]}
  <!-- eslint-disable svelte/no-inline-styles -- Only styles passed to this component should be included -->
  <svg
    {id}
    class="svelte-fa svelte-fa-base {clazz}"
    class:pulse
    class:svelte-fa-size-lg={size === "lg"}
    class:svelte-fa-size-sm={size === "sm"}
    class:svelte-fa-size-xs={size === "xs"}
    class:svelte-fa-fw={fw}
    class:svelte-fa-pull-left={pull === "left"}
    class:svelte-fa-pull-right={pull === "right"}
    class:spin
    bind:this={svgElement}
    {style}
    viewBox="0 0 {i[0]} {i[1]}"
    aria-hidden="true"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- eslint-enable -->
    <g transform="translate({i[0] / 2} {i[1] / 2})" transform-origin="{i[0] / 4} 0">
      <g {transform}>
        {#if typeof i[4] == "string"}
          <path
            d={i[4]}
            fill={color || primaryColor || "currentColor"}
            transform="translate({i[0] / -2} {i[1] / -2})"
          />
        {:else}
          <!-- Duotone icons -->
          <path
            d={i[4][0]}
            fill={secondaryColor || color || "currentColor"}
            fill-opacity={swapOpacity != false ? primaryOpacity : secondaryOpacity}
            transform="translate({i[0] / -2} {i[1] / -2})"
          />
          <path
            d={i[4][1]}
            fill={primaryColor || color || "currentColor"}
            fill-opacity={swapOpacity != false ? secondaryOpacity : primaryOpacity}
            transform="translate({i[0] / -2} {i[1] / -2})"
          />
        {/if}
      </g>
    </g>
  </svg>
{/if}

<style>
  :global(.svelte-fa-base) {
    height: 1em;
    overflow: visible;
    transform-origin: center;
    vertical-align: -0.125em;
  }

  :global(.svelte-fa-fw) {
    text-align: center;
    width: 1.25em;
  }

  .svelte-fa-pull-left {
    float: left;
  }

  .svelte-fa-pull-right {
    float: right;
  }

  .svelte-fa-size-lg {
    font-size: 1.33333em;
    line-height: 0.75em;
    vertical-align: -0.225em;
  }

  .svelte-fa-size-sm {
    font-size: 0.875em;
  }

  .svelte-fa-size-xs {
    font-size: 0.75em;
  }

  .spin {
    animation: spin 2s 0s infinite linear;
  }

  .pulse {
    animation: spin 1s infinite steps(8);
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
